import { useLayoutEffect, useState } from "react";

/**
 * Seconds remaining until `phaseEndsAt` (ISO), **ceil** of wall time (updates ~2×/s).
 * When this reads `1`, that is the last full second before the buzzer — use that for auto-submit
 * (e.g. bluff `"-"`) rather than waiting for `0`, when the server may already reject.
 * `null` if no deadline or invalid.
 */
export function useBluffPhaseCountdown(phaseEndsAt: string | null | undefined): number | null {
  const [secondsLeft, setSecondsLeft] = useState<number | null>(null);

  // useLayoutEffect: recompute before paint so dependents (e.g. auto "-") do not see stale `0`
  // from the previous phase's deadline when `phase_ends_at` has already advanced.
  useLayoutEffect(() => {
    if (!phaseEndsAt) {
      setSecondsLeft(null);
      return;
    }
    const endMs = Date.parse(phaseEndsAt);
    if (Number.isNaN(endMs)) {
      setSecondsLeft(null);
      return;
    }
    const tick = () => {
      const s = Math.max(0, Math.ceil((endMs - Date.now()) / 1000));
      setSecondsLeft(s);
    };
    tick();
    const id = window.setInterval(tick, 500);
    return () => window.clearInterval(id);
  }, [phaseEndsAt]);

  return secondsLeft;
}
